<template>
<!-- :class="{accordeon__active: open}" -->
    <div
        class="accordeon"
        :name="item"
    >
      <div @click="open = !open" class="accordeon_title" v-html="content.text" /> 

        <div v-if="open || content.id == active" class="accordeon_content" >
            <div class="content_title" >
                ОТРАСЛИ ЭКОНОМИКИ И ВЕДУЩИЕ РАБОТОДАТЕЛИ
            </div>

            <div class="department_w">
                <div class="department_l">
                    <img :src="`${$server}p2/${content.id}/b1.svg`" />
                </div>
                <div class="department_r" v-if="content.department">
                    <div class="accordeon_subtitle" v-html="content.department.title" />
                    <ul class="body_ul">
                        <li v-for="li of content.department.list" v-html="li" />
                    </ul>
                </div>
            </div>

            <div class="divide_m" />

            <div class="content_title" >
                ПРОФЕССИОНАЛЬНО ВАЖНЫЕ КАЧЕСТВА И КОМПЕТЕНЦИИ:
            </div>

            <ul class="content_list">
                <li v-for="item of content.list" v-html="item" />
            </ul>

        </div>
    </div>
</template>
<script>
export default {
    name: 'Page2Accordeon',
    data () {
        return {
            open: false,
        }
    },
    props: {
        content: Object,
        item: Number,
        active: Number,
    },
    methods: {
        onOpen () {
            this.open = true
        }
    }
}
</script>
<style lang="stylus">
.navigator_ie
    .accordeon_title
        margin-bottom 10px
</style>